// Assessment.jsx
import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call"; // same helper you use elsewhere
import "./Dashboard.css";

export default function Assessment() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [file, setFile] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const assessmentName =
    localStorage.getItem("currentAssessment") || "Assessment";

  /* ---------------------------------------------
     FETCH AVAILABLE ASSESSMENTS
  --------------------------------------------- */
  useEffect(() => {
    fetchAssessments();
  }, []);

  const fetchAssessments = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("/assessment/list");
      setRows(
        res.map((r, i) => ({
          id: i + 1,
          name: r.dpdpas_assessment_name,
          key: r.dpdpas_assessment_key,
          status: "Pending",
        }))
      );
    } catch (err) {
      console.error(err);
      alert("Failed to load assessments");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------------------
     DOWNLOAD CSV
  --------------------------------------------- */
  const handleDownload = async (name) => {
    const token = localStorage.getItem("access_token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/assessment/download/${name}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      return alert("Download failed");
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  /* ---------------------------------------------
     UPLOAD CSV
  --------------------------------------------- */
  const handleUpload = async () => {
    if (!file) return alert("Please select a CSV file");

    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/assessment/upload/${assessmentName}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    const data = await res.json();

    if (!res.ok) {
      return alert(data.error || "Upload failed");
    }

    alert(`Score: ${data.score}%`);
    setShowForm(false);
    setFile(null);
    fetchAssessments();
  };

  return (
    <div className="general_">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="headSection">
        <div className="compliance-score">{assessmentName}</div>
        <button
          className="action-btn primary"
          onClick={() => setShowForm(true)}
        >
          Upload CSV
        </button>
      </div>

      <table className="data-table" style={{ marginTop: "20px" }}>
        <thead>
          <tr>
            <th>#</th>
            <th>Assessment</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.status}</td>
                <td>
                  <button
                    className="action-btn"
                    onClick={() => handleDownload(row.name)}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Upload Modal */}
      {showForm && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Upload Assessment CSV</h3>

            <input
              type="file"
              accept=".csv"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <div className="modal-actions">
              <button
                className="action-btn primary"
                onClick={handleUpload}
              >
                Upload
              </button>
              <button
                className="action-btn secondary"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
